import { useEffect, useRef } from 'react';
import { AddressElementProps, useElements } from '@stripe/react-stripe-js';
import useConfig from '@sdk/config/useConfig';

import { useBillingView } from '@web/account/billing/BillingViewContext/BillingViewContext';

export const useEditBillingInformation = (withSlingAutocomplete: boolean) => {
  const comapnyNameInputRef = useRef<HTMLInputElement>(null);
  const { GOOGLEMAPS_API_KEY } = useConfig();

  useEffect(() => {
    comapnyNameInputRef?.current.focus();
  }, []);

  const { shouldShowAddressErrors, isSubmitted, setIsSubmitted } = useBillingView();
  const elements = useElements();

  useEffect(() => {
    if (shouldShowAddressErrors && !isSubmitted) {
      setIsSubmitted(true);
      elements.submit();
    }
  }, [shouldShowAddressErrors, isSubmitted, elements, setIsSubmitted]);

  const billingAddressProps: AddressElementProps = withSlingAutocomplete
    ? {
        options: {
          mode: 'billing',
          autocomplete: {
            mode: 'google_maps_api',
            apiKey: GOOGLEMAPS_API_KEY,
          },
        },
      }
    : undefined;

  return {
    comapnyNameInputRef,
    isSubmitted,
    billingAddressProps,
  };
};
